/**
 * The queue rail's Ask Riley lines, per case row, outside React (patchbay#196): expanding the rail remounts it, and
 * the question in flight must still show as working and still receive its answer.
 */
import type { ChatItem } from '../../lib/types'
import { createKeyedStore } from '../riley/chat-store'

export interface QueueRileyChat {
  lines: ChatItem[]
  busy: boolean
}

export const queueRileyChats = createKeyedStore<QueueRileyChat>({ lines: [], busy: false })

export function resetQueueRileyChats(): void {
  queueRileyChats.reset()
}

/** Ask once per row at a time; the answer lands in the store whether or not the rail that asked is still mounted. */
export async function askQueueRiley(rowId: string, text: string, send: (text: string) => Promise<ChatItem[]>): Promise<void> {
  if (queueRileyChats.get(rowId).busy) return
  queueRileyChats.set(rowId, (c) => ({ busy: true, lines: [...c.lines, { id: `u-${Date.now()}`, role: 'user', at: 'Just now', text }] }))
  try {
    const replies = await send(text)
    queueRileyChats.set(rowId, (c) => ({ busy: false, lines: [...c.lines, ...replies] }))
  } catch (reason) {
    const detail = reason instanceof Error ? reason.message : 'Riley could not answer.'
    queueRileyChats.set(rowId, (c) => ({
      busy: false,
      lines: [...c.lines, { id: `e-${Date.now()}`, role: 'riley', at: 'Just now', text: `Riley could not answer: ${detail}` }],
    }))
  }
}
